module.exports = __webpack_public_path__ + "img/dlssr-currency-guide-2.e0163523.png";